import {
  commitMutation,
  graphql
} from 'react-relay';

import environment from '../Environment';

const mutation = graphql`
mutation UpdateContractNumbersMutation($propositionId: ID!, $contractNumbers: [String]!) {
  updateContractNumbers(propositionId: $propositionId, contractNumbers: $contractNumbers) { 
    ok
    error
    contract {
      id
      contractNumbers
    }
  }
}
`;

export default (
  propositionId,
  {
    contractNumbers
  }, done) => {

  const variables = {
    propositionId,
    contractNumbers
  };

  commitMutation(
    environment,
    {
      mutation,
      variables,
      updater: () => {
      },
      optimisticUpdater: () => {
      },
      onCompleted: (response) => {
        const { ok, error } = response.updateContractNumbers;
        done(ok, error);
      },
      onError: err => console.error(err)
    }
  );
};
